<template>
  <div class="container">
    <div class="ui left aligned grid">
      <h1>{{title}} Machine</h1>
    </div>
    <form
      id="MachineDetails"
      class="ui form row segment"
      @submit.prevent="machineUpdate"
    >
      <div class="ui grid stackable">
        <div class="row">
          <div class="eight wide column">
            <label>Machine Code</label>
            <input
              type="text"
              name="machineCode"
              placeholder="Machine Code"
              required
              :disabled="disabled"
              v-model="machineCode"
              :class="{'disabled' : disabled}"
              class="field"
            />
          </div>
        </div>
        <div class="row">
          <div class="eight wide column">
            <label>Machine Name</label>
            <input
              type="text"
              name="machineDesc"
              placeholder="Machine Description"
              v-model="machineDescription"
            />
          </div>
        </div>
        <div class="row">
          <div class="eight wide column">
            <label for="active" class="toggle label">Inactive</label>
            <div class="ui toggle checkbox">
              <input
                id="active"
                name="active"
                type="checkbox"
                tabindex="0"
                class
                v-model="active"
              />
              <label for="active">Active</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="eight wide column">
            <div class="ui buttons">
              <button class="ui positive button">{{button}} Machine</button>
              <div class="or"></div>
              <div class="ui light button" @click="$router.go(-1)">Cancel</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();

export default {
  name: "EditMachine",
  components: {},
  data() {
    return {
      showModal: false,
      machineCode: "",
      machineDescription: "",
      active: true,
      error: "",
      button: "",
      title: "",
      disabled: false
    };
  },
  mounted() {
    if (this.$route.params.id == undefined) {
      this.button = 'Add';
      this.title = 'Add';
      this.disabled = false;
      return false;
    } else {
      this.machineDetails();
      this.button = 'Save';
      this.title = 'Edit';
      this.disabled = true;
    }

    $(".ui.dropdown").dropdown({
      fullTextSearch: true,
      sortSelect: true,
      match: "text",
    });
  },
  computed: {},
  methods: {
    machineDetails() {
      apiService
        .getMachineDetails({ id: this.$route.params.id })
        .then((request) => this.machineSuccessful(request))
        .catch((err) => this.machineFailed(err));
    },
    machineSuccessful(request) {
      (this.machineCode = request.code),
        (this.machineDescription = request.description),
        (this.active = request.active);
    },
    machineFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    machineUpdate() {
      if (this.$route.params.id == undefined) {
        // console.log('create');
        // console.log(this.machineCode);
        apiService
          .createMachine({
            Code: this.machineCode,
            Description: this.machineDescription,
            Active: this.active,
            error: false,
          })
          .then((request) => {
            this.machineSuccessful(request);
            this.$router.push("/admin/machines/machines");
          })
          .catch((err) => this.machineFailed(err));
      } else {
        apiService
          .updateMachine({
            id: this.$route.params.id,
            Code: this.machineCode,
            Description: this.machineDescription,
            Active: this.active,
            error: false,
          })
          .then((request) => {
            this.machineSuccessful(request);
            this.$router.push("/admin/machines/machines");
          })
          .catch((err) => this.machineFailed(err));
      }
    },
  },
};
</script>

<style module></style>
